import { path } from 'ramda';

export const selectLocationType = path(['location', 'type']);

export const selectQueryParams = path(['location', 'query']);
